export const ensureSubs = (exercise) => {
  if (!exercise) return [{
    id: 'sub_default',
    name: 'Main',
    showInKiosk: true,
    fields: { reps: true, weight: true, sets: true, time: true, notes: true }
  }]
  
  if (exercise.subs && exercise.subs.length) return exercise.subs
  
  if (exercise.mode === 'cardio') {
    return [{
      id: exercise._id + '_default',
      name: 'Default',
      showInKiosk: true,
      fields: { primary: true, time: true, notes: true }
    }]
  }
  
  // For strength and workout exercises, enable time by default
  return [{
    id: exercise._id + '_default',
    name: 'Main',
    showInKiosk: true,
    fields: { reps: true, weight: true, sets: true, time: true, notes: true }
  }]
}

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleString()
}

export const renderPayload = (payload, exercise) => {
  if (!payload) return ''
  
  if (payload.type === 'workout') {
    const parts = []
    if (payload.weight != null && payload.weight !== '') {
      parts.push(`${payload.weight}${exercise?.unit || 'lbs'}`)
    }
    if (payload.reps != null && payload.reps !== '') {
      parts.push(`${payload.reps} reps`)
    }
    if (payload.sets != null && payload.sets !== '') {
      parts.push(`${payload.sets} sets`)
    }
    if (payload.time) parts.push(`⏱️ ${payload.time}`)
    if (payload.notes) parts.push(`"${payload.notes}"`)
    return parts.length ? parts.join(' • ') : '(no details)'
  }
  
  if (payload.type === 'strength') {
    const parts = []
    if (payload.weight != null && payload.weight !== '') {
      parts.push(`${payload.weight}${exercise?.unit || 'lbs'}`)
    }
    if (payload.reps != null && payload.reps !== '') {
      parts.push(`${payload.reps} reps`)
    }
    if (payload.sets != null && payload.sets !== '') {
      parts.push(`${payload.sets} sets`)
    }
    if (payload.time) parts.push(`⏱️ ${payload.time}`)
    if (payload.notes) parts.push(`"${payload.notes}"`)
    return parts.length ? parts.join(' • ') : '(no details)'
  } else {
    // Cardio
    const bits = []
    if (payload.value != null && payload.value !== '') {
      const unit = exercise?.unit || (payload.metric === 'distance' ? 'm' : 'cals')
      bits.push(payload.metric === 'distance' ? `${payload.value}${unit}` : `${payload.value} cals`)
    }
    if (payload.time) bits.push(`⏱️ ${payload.time}`)
    if (payload.notes) bits.push(`"${payload.notes}"`)
    return bits.length ? bits.join(' • ') : '(no details)'
  }
}

export const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9)
}
